import React, { memo } from 'react';
import {
  FormPageInputItemPasswordHash,
  PasswordHashTextReEnterInput,
  PasswordHashProperty,
} from 'shared';
import { PasswordHashInputItemProps } from './shared';

type PasswordValue = NonNullable<FormPageInputItemPasswordHash['password']>;

type Props = Omit<
  PasswordHashInputItemProps<
    PasswordHashProperty,
    FormPageInputItemPasswordHash
  >,
  'onPasswordDisplayChange'
> & {
  value: PasswordValue;
};

const PASSWORD_KEY: Extract<keyof FormPageInputItemPasswordHash, 'password'> =
  'password';

export const PasswordHashReEnter: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    value = '',
    onChange,
    onBlur,
    className,
    errorMessages,
    displayError,
    displayPassword,
  }) => {
    const handleChange = (passwordValue: PasswordValue) => {
      onChange(PASSWORD_KEY, passwordValue);
    };
    const handleBlur = (passwordValue: PasswordValue) => {
      onBlur(PASSWORD_KEY, passwordValue);
    };
    return (
      <PasswordHashTextReEnterInput
        propertyId={property.propertyId}
        value={value}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onChange={handleChange}
        onBlur={handleBlur}
        design={design}
        className={className}
        displayPassword={displayPassword}
      />
    );
  },
);
